import { SearchBar } from './SearchBar';
import { ArrowDown } from 'lucide-react';
import { Button } from "@/components/ui/button";

interface HeroProps {
  onSearch: (query: string) => void;
}

export const Hero = ({
  onSearch
}: HeroProps) => {
  const scrollToFeatured = () => {
    const element = document.getElementById('featured-plans');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  
  const quickSearchTerms = [
    { label: 'Fri tale', query: 'Ubegrænset tale' },
    { label: 'Fri data', query: 'Ubegrænset data' },
    { label: 'Streamingtjenester', query: 'streaming' }
  ];
  
  const handleQuickSearch = (query: string) => {
    onSearch(query);
  };
  
  return <section className="relative min-h-screen flex items-center pt-16 pb-20 overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-violet-50 -z-10" />
      
      {/* Decorative circles - reduced opacity and animation */}
      <div className="absolute top-1/4 right-[10%] w-96 h-96 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-10 -z-10" />
      <div className="absolute top-1/2 left-[5%] w-72 h-72 bg-violet-200 rounded-full mix-blend-multiply filter blur-3xl opacity-10 -z-10" />
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block">
            <span className="inline-flex items-center rounded-full bg-brand-100 px-4 py-1.5 text-sm font-medium text-brand-800 mb-6">
              Sammenlign mobilabonnementer fra alle større udbydere på ét sted
            </span>
          </div>
          
          {/* Optimized heading for LCP - removed animations and simplified */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6" id="main-heading">
            Find dit <span className="text-primary">perfekte mobilabonnement</span> på få minutter
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8 mx-auto max-w-2xl">
            Sammenlign priser og funktioner fra førende mobilselskaber. Spar tid og penge ved at finde det rigtige abonnement til dine behov.
          </p>
          
          <div className="max-w-2xl mx-auto">
            <SearchBar onSearch={onSearch} onClose={() => {}} />
            
            {/* Quick search buttons */}
            <div className="mt-4 flex flex-wrap justify-center gap-2">
              <span className="text-sm text-muted-foreground mr-2 flex items-center">Hurtig søgning:</span>
              {quickSearchTerms.map((term) => (
                <Button
                  key={term.query}
                  variant="outline"
                  size="sm"
                  onClick={() => handleQuickSearch(term.query)}
                  className="bg-white/50 hover:bg-white/70 border-primary/20 text-foreground"
                >
                  {term.label}
                </Button>
              ))}
            </div>
          </div>
          
          <button onClick={scrollToFeatured} className="mt-16 inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors">
            <span className="mr-2">Scroll for at se anbefalede abonnementer</span>
            <ArrowDown className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>;
};
